import React, { useEffect, useContext } from 'react'
import { SectionHeading } from '../../../../../Components/Headers'
import { PlayerProfileContext } from '../../../../../Context'
import { ValuesInRowContainer } from '../../Value'

type CurrentStatsParams = {
  league?: string | null
  color?: string
}

export const CurrentSeasonStats: React.FC<
  React.PropsWithChildren<CurrentStatsParams>
> = ({ league = 'PLL', color }) => {
  const { statsLoaded, seasonStats, seasonSelect, getStats } =
    useContext(PlayerProfileContext)!

  useEffect(() => {
    if (!seasonStats) return
  }, [seasonStats])

  const renderTitle = (seasonType: string) => {
    const title = {
      regular: `${seasonSelect.year} Season Stats`,
      post: `${seasonSelect.year} Postseason Stats`,
      champseries: `Championship Series Stats`,
    }[seasonType]
    return title
  }

  return (
    <>
      {league === 'MLL' && <div>🥍 Stats from {seasonSelect.year} MLL Season</div>}
      <SectionHeading>
        <strong>{renderTitle(seasonSelect.seasonType)}</strong>
      </SectionHeading>
      {seasonStats && statsLoaded && (
        <ValuesInRowContainer
          values={getStats('season', false, seasonStats)}
          color={color}
          switchOn="md"
        />
      )}
    </>
  )
}
